import React from 'react'
import { ReviewApplicationIcon } from '../../assets';
import { DropdownIcon } from '../../assets/icons';
import { IP_WHITELISTING_REQUIREMENTS, NOTE_COLORS } from '../../data';

interface IProps {
    isExpanded: boolean;
    onToggle: () => void;
}

const IPWhitelistingNotes = ({ isExpanded, onToggle }: IProps) => {
    return (
        <div className="accordion-item">
            <div className="title-box" onClick={onToggle} style={{ cursor: 'pointer' }}>
                <div className="icon-box">
                    <img src={ReviewApplicationIcon} alt="api-packages" />
                </div>
                <h4>IP Whitelisting Requirements</h4>
                <span className={`dropdown-chevron-container ${isExpanded ? 'rotate' : 'no-rotate'}`}>
                    <img src={DropdownIcon} alt="dropdown" className="dropdown-chevron" />
                </span>

            </div>
            {isExpanded && (
                <div className="ip-whitelisting-requirements">
                    <p className="requirements-subtitle">
                        We request you to keep these documents ready to ensure a smooth and swift movement for ULI Integration.
                    </p>

                    <div className="requirements-list">
                        {IP_WHITELISTING_REQUIREMENTS.map((item, index) => (
                            <div className="requirement-item" key={index} style={{
                                borderLeft: `4px solid ${NOTE_COLORS[index % NOTE_COLORS.length].border}`,
                                background: NOTE_COLORS[index % NOTE_COLORS.length].bg,
                            }}>
                                <h5>{item.title}</h5>
                                <p>{item.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}

export default IPWhitelistingNotes
